<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects'"
            >Projects</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/project/' + activeProjectID"
            >{{ activeProjectCode }}</router-link
          >
        </li>
      </ol>
    </div>
    <spinner style="margin-top: 60px" v-if="searchingProject" />

    <div
      v-else
      style="
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 50px;
        margin-top: 60px;
      "
    >
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            min-height: 75px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            flex-direction: row !important;
          "
        >
          <div style="padding-left: 50px; font-size: 18px" class="col-6">
            {{ activeProject.code }} - {{ activeProject.name }}
          </div>
          <div class="col-6" style="text-align: end; padding-right: 50px">
            <button
              style="border-radius: 30px; padding: 6px 12px; margin-right: 10px"
              type="button"
              class="btn btn-warning"
              @click="redirectToUpdateProject()"
            >
              <i
                style="padding-top: 5px; color: white"
                class="fa fa-arrow-up"
              ></i>
            </button>
            <button
              style="border-radius: 30px; padding: 6px 12px"
              @click="deleteProject()"
              type="button"
              class="btn btn-danger"
            >
              <i style="padding-top: 5px" class="fa fa-trash"></i>
            </button>
          </div>
        </md-card>
      </div>

      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            border-top-right-radius: 30px;
            border-top-left-radius: 30px;
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleProjectDetails()"
              class="col-6"
            >
              Project Details
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showProjectDetails ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showProjectDetails ? 'display: flex' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-8">
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Code</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.code }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Name</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.name }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Description</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.description }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Asset</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.asset.code }} -
                  {{ activeProject.asset.name }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Start Date</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.start_date }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >End Date</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.end_date }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Duration</label
                >
                <label style="line-height: normal" class="col-9">
                  {{
                    getProjectDuration(
                      activeProject.start_date,
                      activeProject.end_date
                    )
                  }}</label
                >
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Maturity</label
                >
                <label style="line-height: normal" class="col-9">
                  {{
                    maturityList.find((maturity) => {
                      return maturity.id == activeProject.maturity;
                    }).name
                  }}</label
                >
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Status</label
                >
                <label style="line-height: normal" class="col-9">
                  {{
                    statusList.find((status) => {
                      return status.id == activeProject.status;
                    }).name
                  }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Project Activity</label
                >
                <label style="line-height: normal" class="col-9">
                  {{
                    activityList.find((activity) => {
                      return activity.id == activeProject.project_activity;
                    }).name
                  }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Region</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.region_code }}
                </label>
              </div>
              <div class="col-12 projectInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Location</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeProject.city }} - {{ activeProject.country_name }}
                </label>
              </div>
            </div>
            <div v-if="activeProject.project_image" class="col-4">
              <div
                style="
                  justify-content: center;
                  margin: 10px;
                  padding: 0;
                  height: 250px;
                "
              >
                <div style="width: 100%; height: 100%; display: flex">
                  <img
                    style="
                      object-fit: contain;
                      display: block;
                      max-height: 100%;
                      max-width: 100%;
                    "
                    :src="
                      'data:image/' +
                      activeProject.project_image.extension +
                      ';base64,' +
                      activeProject.project_image.image
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleProjectFinancials()"
              class="col-6"
            >
              Project Financials
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showProjectFinancials ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showProjectFinancials ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Principal Native</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  fixNumberView(
                    activeProject.project_financials.principal_native
                  )
                }}
                {{ activeProject.project_financials.currency_code }}
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.currency_code != 'USD'"
              class="col-12 projectInfoClass"
            >
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Principal Native (USD)</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  fixNumberView(
                    activeProject.project_financials.principal_native *
                      activeProject.project_financials.exchange_rate
                  )
                }}
                USD
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.currency_code != 'USD'"
              class="col-12 projectInfoClass"
            >
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Exchange Rate</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.exchange_rate }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Special Discount</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.special_discount }}%
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Taxation</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.taxation }}%
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Final Price</label
              >
              <label style="line-height: normal" class="col-9">
                {{ fixNumberView(calculateFinalPrice()) }}
                {{ activeProject.project_financials.currency_code }}
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.currency_code != 'USD'"
              class="col-12 projectInfoClass"
            >
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Final Price (USD)</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  calculateFinalPrice() *
                  activeProject.project_financials.exchange_rate
                }}
                USD
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Estimated ROI</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.estimated_roi }}%
                {{
                  periodList.find((period) => {
                    return (
                      period.id == activeProject.project_financials.roi_period
                    );
                  }).name
                }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Debt?</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  activeProject.project_financials.debt ? "Debted" : "No Debt"
                }}
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.debt"
              class="col-12 projectInfoClass"
            >
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Installments</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.installment_number }}
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.debt"
              class="col-12 projectInfoClass"
            >
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Installment Value</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.installment_value }}
                {{ activeProject.project_financials.currency_code }}
                {{
                  periodList.find((period) => {
                    return (
                      period.id ==
                      activeProject.project_financials.installment_period
                    );
                  }).name
                }}
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.debt"
              class="col-12 projectInfoClass"
            >
              <label
                v-if="activeProject.project_financials.cost_increase"
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Cost Increase</label
              >
              <label
                v-if="activeProject.project_financials.cost_increase_period"
                style="line-height: normal"
                class="col-9"
              >
                {{ activeProject.project_financials.cost_increase }} %
                {{
                  periodList.find((period) => {
                    return (
                      period.id ==
                      activeProject.project_financials.cost_increase_period
                    );
                  }).name
                }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Real Estate?</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.is_estate ? "Yes" : "No" }}
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.is_estate"
              class="col-12 projectInfoClass"
            >
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Area</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.estate_area }}
                {{ activeProject.project_financials.unit }}
              </label>
            </div>
            <div
              v-if="activeProject.project_financials.is_estate"
              class="col-12 projectInfoClass"
            >
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Unit Price</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.project_financials.unit_price }}
              </label>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleProjectRating()"
              class="col-6"
            >
              Project Rating
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showProjectRating ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showProjectRating ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Risk Level</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  levels.find((level) => {
                    return level.id == activeProject.project_rating.risk_level;
                  }).name
                }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Risk Reward</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  levels.find((level) => {
                    return level.id == activeProject.project_rating.risk_reward;
                  }).name
                }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Resilience</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  levels.find((level) => {
                    return level.id == activeProject.project_rating.resilience;
                  }).name
                }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Anti-Fragility</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  levels.find((level) => {
                    return (
                      level.id == activeProject.project_rating.anti_fragility
                    );
                  }).name
                }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Impacted Parties</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  impactedParties.find((party) => {
                    return (
                      party.id == activeProject.project_rating.impacted_parties
                    );
                  }).name
                }}
              </label>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleProjectFiles()"
              class="col-6"
            >
              Project Files
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showProjectFiles ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showProjectFiles ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 projectInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>File Name</th>
                    <th>File Type</th>
                    <th>File Size</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(file, key) in activeProject.files"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>
                      {{
                        file.project_file.caption
                          .split(".")
                          .slice(0, -1)
                          .join(".")
                      }}
                    </td>
                    <td>{{ file.project_file.extension }}</td>
                    <td>{{ bytesToSize(file.project_file.size) }}</td>
                    <td>
                      <a
                        style="color: rgb(140, 198, 63) !important"
                        :href="file.project_file.url"
                        target="_blank"
                        download
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleProjectTransactions()"
              class="col-6"
            >
              Project Transactions
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showProjectTransactions
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              showProjectTransactions ? 'display: block' : 'display: none'
            "
            style="min-height: 100px"
          >
            <div class="col-12 projectInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Exchange Rate</th>
                    <th>Final Amount (USD)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(transaction, key) in transactions"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ transaction.date }}</td>
                    <td>
                      {{
                        transactionTypes.find((type) => {
                          return type.id == transaction.type;
                        }).name
                      }}
                    </td>
                    <td>
                      {{ fixNumberView(transaction.amount) }}
                      {{ transaction.currency.code }}
                    </td>
                    <td>
                      {{ transaction.exchange_rate }}
                    </td>
                    <td>
                      {{
                        fixNumberView(
                          transaction.amount * transaction.exchange_rate
                        )
                      }}
                      USD
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleProjectValuations()"
              class="col-6"
            >
              Project Valuations
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showProjectValuations ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showProjectValuations ? 'display: block' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-12 projectInfoClass" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>Year</th>
                    <th>Quarter</th>
                    <!-- <th>Value</th>
                    <th>Exchange Rate</th> -->
                    <th>Valuation (USD)</th>
                    <th>Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(valuation, key) in valuations"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>
                      {{ valuation.year }}
                    </td>
                    <td>
                      {{ valuation.quarter_number }}
                    </td>
                    <!-- <td>
                      {{ fixNumberView(valuation.value) }}
                    </td>
                    <td>
                      {{ valuation.exchange_rate }}
                    </td> -->
                    <td>
                      {{
                        fixNumberView(valuation.value * valuation.exchange_rate)
                      }}
                      USD
                    </td>
                    <td>{{ valuation.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            border-bottom-right-radius: 30px;
            border-bottom-left-radius: 30px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleProjectExitStrategy()"
              class="col-6"
            >
              Exit Strategy
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showProjectExitStrategy
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              showProjectExitStrategy ? 'display: block' : 'display: none'
            "
            style="min-height: 100px"
          >
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Exit Cause</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.exit_cause }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Exist Analysis Period</label
              >
              <label style="line-height: normal" class="col-9">
                {{
                  periodList.find((period) => {
                    return period.id == activeProject.exit_analysis;
                  }).name
                }}
              </label>
            </div>
            <div class="col-12 projectInfoClass">
              <label
                class="col-3"
                style="padding: 0; font-size: 13px; font-weight: bold"
                >Method</label
              >
              <label style="line-height: normal" class="col-9">
                {{ activeProject.method }}
              </label>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from "vue-simple-spinner";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import ProjectsFilter from "../../filters/ProjectsFilter";
import TransactionsFilter from "../../filters/TransactionsFilter";
import ProjectValuationsFilter from "../../filters/ProjectValuationsFilter";
import moment from "moment";

export default {
  name: "project",
  data() {
    return {
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      maturityList: [
        { id: "shortterm", name: "Short Term" },
        { id: "mediumterm", name: "Medium Term" },
        { id: "longterm", name: "Long Term" },
      ],
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      activityList: [
        { id: "active", name: "Active" },
        { id: "semipassive", name: "Semi Passive" },
        { id: "passive", name: "Passive" },
      ],
      periodList: [
        { id: "monthly", name: "Monthly" },
        { id: "quarterly", name: "Quarterly" },
        { id: "biannually", name: "Bi-Annually" },
        { id: "annually", name: "Annually" },
      ],
      levels: [
        { id: "low", name: "Low" },
        { id: "medium", name: "Medium" },
        { id: "high", name: "High" },
      ],
      impactedParties: [
        { id: "community", name: "Community" },
        { id: "environment", name: "Environment" },
        { id: "both", name: "Both" },
        { id: "none", name: "None" },
      ],
      showProjectDetails: false,
      showProjectFinancials: false,
      showProjectRating: false,
      showProjectExitStrategy: false,
      showProjectTransactions: false,
      showProjectValuations: false,
      showProjectFiles: false,
      activeProjectID: null,
      activeProjectCode: null,
    };
  },
  created: function () {
    this.activeProjectID = this.$route.params.projectId;
    this.activeProjectCode = this.$route.params.projectCode;
    var projectsFilter = ProjectsFilter();
    projectsFilter.ids = [this.activeProjectID];
    projectsFilter.with = [
      "projectFinancials",
      "projectRating",
      "asset",
      "files",
      "projectImage",
    ];
    this.$store
      .dispatch("searchProjects", {
        filter: projectsFilter,
        resultMode: "default",
      })
      .then(() => {
        var transactionsFilter = TransactionsFilter();
        transactionsFilter.account_ids = [this.activeProject.account_id];
        transactionsFilter.account_types = ["project_account"];
        this.$store.dispatch("searchTransactions", {
          filter: transactionsFilter,
          resultMode: "default",
        });
      });
    var projectValuationsFilter = ProjectValuationsFilter();
    projectValuationsFilter.project_ids = [this.activeProjectID];
    this.$store.dispatch("searchProjectValuations", {
      filter: projectValuationsFilter,
      resultMode: "default",
    });
  },
  components: {
    Spinner,
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      activeProject: (state) => state.projectStore.projectSearch.projects[0],
      transactions: (state) =>
        state.transactionStore.transactionSearch.transactions,
      deleteProjectStatus: (state) =>
        state.projectStore.projectDelete.deleteProjectStatus,
      searchingProject: (state) =>
        state.projectStore.projectSearch.searchingProjects,
      valuations: (state) =>
        state.projectValuationStore.projectValuationSearch.projectValuations,
    }),
  },
  methods: {
    calculateFinalPrice() {
      var price_with_special_discount =
        this.activeProject.project_financials.principal_native -
        (this.activeProject.project_financials.special_discount *
          this.activeProject.project_financials.principal_native) /
          100;

      return (
        this.activeProject.project_financials.principal_native -
        (this.activeProject.project_financials.special_discount *
          this.activeProject.project_financials.principal_native) /
          100 +
        (this.activeProject.project_financials.taxation *
          price_with_special_discount) /
          100
      );
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    toggleProjectDetails() {
      this.showProjectDetails = !this.showProjectDetails;
    },
    toggleProjectFinancials() {
      this.showProjectFinancials = !this.showProjectFinancials;
    },
    toggleProjectRating() {
      this.showProjectRating = !this.showProjectRating;
    },
    toggleProjectExitStrategy() {
      this.showProjectExitStrategy = !this.showProjectExitStrategy;
    },
    toggleProjectTransactions() {
      this.showProjectTransactions = !this.showProjectTransactions;
    },
    toggleProjectValuations() {
      this.showProjectValuations = !this.showProjectValuations;
    },
    toggleProjectFiles() {
      this.showProjectFiles = !this.showProjectFiles;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    getProjectDuration(start, end) {
      let duration = moment.duration(moment(start).diff(moment(end)));
      let durationString = "";
      if (duration.years() / -1) {
        durationString += duration.years() / -1 + " Years, ";
      }
      if (duration.months() / -1) {
        durationString += duration.months() / -1 + " Months, ";
      }
      if (duration.days() / -1) {
        durationString += duration.days() / -1 + " Days, ";
      }
      durationString = durationString.substring(0, durationString.length - 2);
      return durationString;
    },
    redirectToUpdateProject() {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/project/" +
          this.activeProject.code +
          "/update/" +
          this.activeProject.id
      );
    },
    deleteProject() {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this project?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteProject", this.activeProject.id);
        }
      });
    },
  },
  watch: {
    deleteProjectStatus() {
      if (this.deleteProjectStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Project has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/projects");
        });
      } else if (this.deleteProjectStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Project delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style>
.projectInfoClass {
  padding-left: 75px;
  display: flex;
  align-items: start;
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/admin/project.vue